import type { TenantConfig } from '@/types/index';

/**
 * Claridyne Health Plan — synthetic DEMO tenant.
 *
 * A fully fictional health plan used to exercise every portal feature with
 * synthetic data (see project "26.06.26, Claridyne Health Demo Portal"). One FOBT
 * campaign, folder "05 Claridyne FOBT", route slug `claridynefobt`.
 *
 * tenant_type=demo. The demo banner is data-driven (demo_mode in
 * 00 Global Setup.xlsx), so this config carries only brand + program identity.
 * Resolved in dev via ?tenant=claridyne (src/tenants/index.ts).
 */
export const claridyneTenant: TenantConfig = {
  tenantId: 'claridyne',
  tenantName: 'Claridyne Health Plan',
  tenantType: 'demo',
  programs: ['claridynefobt'],
  brandTokens: {
    primaryHex: '#0E5FA8', // Claridyne clinical blue
    accentHex: '#0E726E', // teal accent
    logoUrl: '/branding/claridyne/logo.svg',
    fontFamily: "'Inter Variable', Inter, system-ui, sans-serif",
  },
  freshness: { kind: 'fresh', snapshotDate: new Date().toISOString().slice(0, 10) },
};
